import { render, staticRenderFns } from "./vip-customer-approved.vue?vue&type=template&id=38f125d4&scoped=true"
import script from "./vip-customer-approved.vue?vue&type=script&lang=js"
export * from "./vip-customer-approved.vue?vue&type=script&lang=js"
import style0 from "./vip-customer-approved.vue?vue&type=style&index=0&id=38f125d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f125d4",
  null
  
)

export default component.exports